import React from 'react';
import { Button, TableCell, TableRow, Badge } from '@material-ui/core';
import moment from 'moment';
import SystemUpdateAltRoundedIcon from '@material-ui/icons/SystemUpdateAltRounded';
import CardTravelRoundedIcon from '@material-ui/icons/CardTravelRounded';
import CancelPresentationRoundedIcon from '@material-ui/icons/CancelPresentationRounded';
import AssignmentIcon from '@material-ui/icons/Assignment';

const BonusProductQRCodeGroupTableRow = (props) => {
  const { QRCodeGroup, isLoading, downloadQRCode, openDetail } = props;

  const handleDownloadQRCode = () => {
    downloadQRCode(QRCodeGroup);
  };

  const handleViewDetail = () => {
    openDetail(QRCodeGroup.groupId);
  };

  return (
    <TableRow>
      <TableCell component="th">{QRCodeGroup.groupId}</TableCell>
      <TableCell component="th">{QRCodeGroup.qRCodeValue}</TableCell>
      <TableCell>
        {QRCodeGroup && QRCodeGroup.groupSize > 0 ? (
          <Badge color="primary" badgeContent={QRCodeGroup.groupSize}>
            <CardTravelRoundedIcon />
          </Badge>
        ) : (
          <CancelPresentationRoundedIcon color="disabled" />
        )}
      </TableCell>
      <TableCell>
        {moment(QRCodeGroup.createdDate).format('YYYY-MM-DD')}
      </TableCell>
      <TableCell align="right">
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<SystemUpdateAltRoundedIcon />}
          disabled={isLoading}
          style={{ marginRight: '12px' }}
          onClick={handleDownloadQRCode}>
          下載 QRCode
        </Button>

        <Button
          variant="contained"
          color="default"
          size="small"
          startIcon={<AssignmentIcon />}
          disabled={isLoading}
          onClick={handleViewDetail}>
          檢視
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default BonusProductQRCodeGroupTableRow;
